import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ordersData } from "../common/globalapi/Api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Images from "../../assets/images/Images";
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import {
    handlePosPrint, PRINTER_PROFILES,
    debugReceiptText,
    debugReceiptBytes,
    debugRawBtUrl,
} from "../../utils/posPrint";

const ViewSales = () => {
    const [searchTerm, setSearchTerm] = useState("");
    let role = sessionStorage.getItem("rolebase");
    let userId = sessionStorage.getItem("userId");

    const navigate = useNavigate();
    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    const [selectedRows, setSelectedRows] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [ismodelOpen, setIsmodelOpen] = useState(false);
    const [orderFormData, setOrderFormData] = useState(null);
    const popupRef = useRef(null);
    const [billingType, setBillingType] = useState(window.innerWidth <= 768 ? "mobile" : "direct");

    useEffect(() => {
        const handleResize = () => setBillingType(window.innerWidth <= 768 ? "mobile" : "direct");
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // const handlePrint = async () => {
    //     try {
    //         await handlePosPrint(orderFormData, () => {
    //             // after print success
    //             setIsPopupOpen(false);
    //         }, {
    //             profile: PRINTER_PROFILES.EPSON_80, // for your XP-C230
    //             transport: "auto", // auto detects Android / Web Serial
    //         });

    //     } catch (err) {
    //         console.error(err);
    //         alert("Printing failed: " + err.message);
    //     }
    // };


    const handlePrint = async () => {
        try {
            await handlePosPrint(
                orderFormData,
                async () => {
                    setIsPopupOpen(false);
                },
                {
                    profile: PRINTER_PROFILES.EPSON_80,
                    transport: "rawbt",
                    cutPaper: false,
                    footerPaddingLines: 5,
                    feedBeforeCutLines: 8,
                }
            );
        } catch (err) {
            console.error(err);
            alert("Printing failed: " + err.message);
        }
    };
    const handleSelfTest = () => {
        try {
            const text = debugReceiptText(orderFormData, PRINTER_PROFILES.EPSON_80, {
                footerPaddingLines: 5,
            });

            const bytes = debugReceiptBytes(orderFormData, PRINTER_PROFILES.EPSON_80, {
                cutPaper: false,
                footerPaddingLines: 5,
                feedBeforeCutLines: 8,
            });

            const rawbtUrl = debugRawBtUrl(orderFormData, PRINTER_PROFILES.EPSON_80, {
                cutPaper: false,
                footerPaddingLines: 5,
                feedBeforeCutLines: 8,
            });

            console.log("===== RECEIPT TEXT =====");
            console.log(text);
            console.log("===== RECEIPT BYTES =====");
            console.log(bytes);
            console.log("===== RAWBT URL =====");
            console.log(rawbtUrl);

            alert("Self-test passed. Open console to verify receipt text, bytes, and RawBT URL.");
        } catch (err) {
            console.error("Self-test failed:", err);
            alert("Self-test failed: " + (err?.message || "Unknown error"));
        }
    };

    const handlePopupCancel = () => {
        setIsPopupOpen(false);
        setOrderFormData(null);
    };

    const handleOpenPrintPopup = (order) => {
        const formData = {
            customerName: order?.customerName || "",
            contactNumber: order?.contactNumber || order?.contact || "",
            salesDate: order?.salesDate || order?.orderDate || order?.createdAt || moment().format("YYYY-MM-DD"),
            totalAmount: Number(order?.totalAmount ?? order?.total ?? 0),
            transactionMode: order?.transactionMode || "",
            invoiceNo: order?.invoiceNo || order?.orderId || "",
            items: (order?.items || order?.products || []).length > 0
                ? (order?.items || order?.products).map(p => ({
                    productName: p?.productName || p?.itemName || p?.product || "",
                    quantity: Number(p?.quantity || 1),
                    unitPrice: Number(p?.unitPrice || p?.highLevelCustomerPrice || p?.purchasePrice || p?.price || 0),
                    price: Number(p?.price || (Number(p?.quantity || 1) * Number(p?.unitPrice || p?.highLevelCustomerPrice || p?.purchasePrice || p?.price || 0)))
                }))
                : (order?.productName || order?.itemName) ? [{
                    productName: order?.productName || order?.itemName,
                    quantity: Number(order?.quantity || 1),
                    unitPrice: Number(order?.unitPrice || order?.highLevelCustomerPrice || order?.purchasePrice || order?.price || 0),
                    price: Number(order?.price || (Number(order?.quantity || 1) * Number(order?.unitPrice || order?.highLevelCustomerPrice || order?.purchasePrice || order?.price || 0)))
                }] : []
        };
        setOrderFormData(formData);
        setIsPopupOpen(true);
    };

    const [activeTab, setActiveTab] = useState("pending"); // NEW: pending | completed

    const fromDate = watch("fromDate");
    const toDate = watch("toDate");

    const [popupType, setPopupType] = useState({
        type: "",
        data: "",
    });
    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupType({
            type: "",
            data: "",
        });
    };

    // GET API START
    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ["ordersData", userId],
        queryFn: () => ordersData(userId),
        enabled: !!userId,
        refetchOnWindowFocus: false,
    });

    let details = (data && data?.data) || [];

    // GET API END

    const filteredDetails =
        details &&
        details
            ?.filter((item) => {
                const lowerSearch = searchTerm?.toLowerCase() || "";

                // Text search: Executive, Customer OR Route Number
                const nameMatch = item?.executiveName
                    ?.toLowerCase()
                    .startsWith(lowerSearch);

                const customerMatch = String(item?.customerName)
                    ?.toLowerCase()
                    .startsWith(lowerSearch);

                const routeNoMatch = item?.lineroute
                    ?.toLowerCase()
                    .startsWith(lowerSearch);

                const textMatch = nameMatch || customerMatch || routeNoMatch;

                // Date filter
                const itemDateStr = item?.salesDate
                    ? moment(item?.salesDate).format("YYYY-MM-DD")
                    : null;

                const fromDateStr = fromDate
                    ? moment(fromDate).format("YYYY-MM-DD")
                    : null;

                const toDateStr = toDate ? moment(toDate).format("YYYY-MM-DD") : null;

                const fromDateMatch = !fromDateStr || itemDateStr >= fromDateStr;
                const toDateMatch = !toDateStr || itemDateStr <= toDateStr;

                const dateMatch = fromDateMatch && toDateMatch;

                return textMatch && dateMatch;
            })
            ?.sort((a, b) => new Date(b.salesDate) - new Date(a.salesDate));

    const todayStr = moment().format("YYYY-MM-DD");

    // const filteredDetails =
    //   details &&
    //   details
    //     ?.filter((item) => {
    //       // 1️⃣ Skip Delivered or Completed orders
    //       if (
    //         item?.deliveryStatus?.toLowerCase() === "delivered" ||
    //         item?.transactionStatus?.toLowerCase() === "completed"
    //       ) {
    //         return false;
    //       }

    //       // 2️⃣ Format dates
    //       const itemDateStr = item?.salesDate
    //         ? moment(item?.salesDate).format("YYYY-MM-DD")
    //         : null;

    //       const fromDateStr = fromDate
    //         ? moment(fromDate).format("YYYY-MM-DD")
    //         : null;

    //       const toDateStr = toDate ? moment(toDate).format("YYYY-MM-DD") : null;

    //       const fromDateMatch = !fromDateStr || itemDateStr >= fromDateStr;
    //       const toDateMatch = !toDateStr || itemDateStr <= toDateStr;
    //       const dateMatch = fromDateMatch && toDateMatch;

    //       // 3️⃣ Search filter → Include executive, customer, AND now route no
    //       const lowerSearch = searchTerm?.toLowerCase() || "";

    //       const nameMatch = item?.executiveName
    //         ?.toLowerCase()
    //         .includes(lowerSearch);
    //       const customerMatch = String(item?.customerName)
    //         ?.toLowerCase()
    //         .includes(lowerSearch);
    //       const routeNoMatch = item?.lineroute
    //         ?.toLowerCase()
    //         .includes(lowerSearch);

    //       const textMatch = nameMatch || customerMatch || routeNoMatch;

    //       // 4️⃣ Dropdown filters
    //       const executiveMatch =
    //         !selectedExecutive || item?.executiveName === selectedExecutive;
    //       const routeMatch = !selectedRoute || item?.lineroute === selectedRoute;

    //       // 5️⃣ Default filter (show only today's records when no filters applied)
    //       const noFiltersApplied =
    //         !searchTerm &&
    //         !fromDate &&
    //         !toDate &&
    //         !selectedExecutive &&
    //         !selectedRoute;

    //       const todayMatch = noFiltersApplied ? itemDateStr === todayStr : true;

    //       return (
    //         textMatch && executiveMatch && routeMatch && dateMatch && todayMatch
    //       );
    //     })
    //     ?.sort((a, b) => new Date(b.salesDate) - new Date(a.salesDate));

    // DashboadDetails
    let overallOrdes = filteredDetails && filteredDetails?.length;
    const processingCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "processing"
        ).length;
    const CanceledCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "canceled"
        ).length;
    const returnedCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "return"
        ).length;
    const deliveredCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "delivered"
        ).length;

    // NEW: Split into pending & completed using existing filteredDetails
    const pendingDetails =
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() !== "delivered"
        ) || [];

    const completedDetails =
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "delivered"
        ) || [];

    // Decide which rows to show in table
    const rowsToShow =
        activeTab === "pending" ? pendingDetails : completedDetails;

    // SELECT ALL IMAGE
    // Keep original allRowIds for popup/download logic (all filteredDetails)
    const allRowIds = filteredDetails?.map((data) => data?.orderId);

    // New: tableRowIds only for current tab selection
    const tableRowIds = rowsToShow?.map((data) => data?.orderId) || [];

    const isAllSelected = tableRowIds.length > 0 && tableRowIds.every((id) => (selectedRows || []).includes(id));

    const handleSelectAll = () => {
        if (isAllSelected) {
            // unselect only those in current tab
            setSelectedRows((prev) => (prev || []).filter((id) => !tableRowIds.includes(id)));
        } else {
            // add all orderId from current tab, keep others
            const newIds = (rowsToShow || []).map(r => r.orderId).filter(id => id != null && !(selectedRows || []).includes(id));
            setSelectedRows((prev) => [...(prev || []), ...newIds]);
        }
    };
    // SELECT END

    // DELETE API
    // Delete a user by item object
    const deleteUser = async (item) => {
        try {
            const registerId = item?.registerId || sessionStorage.getItem("userId") || item?.userId || 1;
            const host = process.env.REACT_APP_HOST || 'https://capi.2kvirtualworld.com/b2bfastbilling';
            const url = `${host}/api/orders/${registerId}/${item.orderId}`;
            console.log('Deleting order URL:', url);
            const response = await axios.delete(url);
            return response.data;
        } catch (error) {
            console.error(`Error deleting order with ID ${item.orderId}:`, error?.response || error.message || error);
            throw error;
        }
    };

    const deleteUsers = async (items) => {
        try {
            // `items` is an array of orderId values — map them to actual objects from `filteredDetails`.
            const itemsToDelete = (items || []).map((orderId) => {
                const found = filteredDetails?.find((d) => d?.orderId === orderId);
                return found || { orderId };
            });

            console.log('Deleting items:', itemsToDelete.map(it => it.orderId));

            const results = await Promise.all(itemsToDelete.map(deleteUser));
            return results; // Return all results after deletion
        } catch (error) {
            console.error("Error deleting multiple orders:", error?.response || error.message || error);
            throw new Error("Failed to delete multiple orders");
        }
    };


    // Mutation to delete users
    const { mutate, isPending: deleteLoading } = useMutation({
        mutationFn: deleteUsers,
        onSuccess: () => {
            toast.success("Orders Deleted Successfully!");
            setSelectedRows([]);
            refetch();
        },
        onError: (error) => {
            console.error("Error deleting rows:", error);
            toast.error("Error deleting rows");
        },
    });

    // Handle checkbox change
    const handleCheckboxChange = (id) => {
        setSelectedRows((prevSelectedRows) => {
            const prev = prevSelectedRows || [];
            const isSelected = prev.includes(id);
            if (isSelected) {
                return prev.filter((rowId) => rowId !== id);
            } else {
                return [...prev, id];
            }
        });
    };
    // Handle delete button click
    const handleDelete = () => {
        if (selectedRows?.length === 0) {
            toast.warn("No rows selected");
            return;
        }
        if (window.confirm("Are you sure you want to delete the selected order details?")) {
            mutate(selectedRows);
        }
    };

    // DELETE API END

    // DOWNLOAD EXCEL
    const downloadExcel = () => {
        // Try multiple data sources for maximum safety
        let sourceData = [];
        if (Array.isArray(filteredDetails) && filteredDetails.length > 0) {
            sourceData = filteredDetails;
        } else if (Array.isArray(details) && details.length > 0) {
            sourceData = details;
        } else if (Array.isArray(data?.data) && data.data.length > 0) {
            sourceData = data.data;
        } else if (Array.isArray(data) && data.length > 0) {
            sourceData = data;
        }

        console.log("Download Excel - sourceData length:", sourceData.length);
        console.log("Download Excel - first record:", sourceData[0]);

        if (sourceData.length === 0) {
            toast.warn("No data available to download");
            return;
        }

        const headers = [
            "ORDER ID",
            "CUSTOMER",
            "PRODUCT",
            "QUANTITY",
            "UNIT PRICE",
            "TOTAL",
            "RECEIVED",
            "BALANCE",
            "TRANSACTION MODE",
            "TRANSACTION STATUS",
            "DELIVERY STATUS",
            "DATE",
        ];

        const formatRows = (rows) => {
            if (!rows || rows.length === 0) return [];
            return rows.map((item) => {
                const items = Array.isArray(item?.items) ? item.items : [];
                const row = {
                    "ORDER ID": item?.orderId != null ? item.orderId : (item?.id != null ? item.id : "-"),
                    "CUSTOMER": item?.customerName || item?.customer || "-",
                    "PRODUCT": items.length > 0
                        ? items.map((d) => d?.productName || d?.product || "-").join(", ")
                        : item?.productName || item?.product || "-",
                    "QUANTITY": items.length > 0
                        ? items.map((d) => d?.quantity ?? 0).join(", ")
                        : (item?.quantity ?? "-"),
                    "UNIT PRICE": items.length > 0
                        ? items.map((d) => d?.unitPrice ?? 0).join(", ")
                        : (item?.unitPrice ?? "-"),
                    "TOTAL": item?.totalAmount ?? 0,
                    "RECEIVED": item?.receivedAmount ?? 0,
                    "BALANCE": item?.balanceAmount ?? 0,
                    "TRANSACTION MODE": item?.transactionMode || "-",
                    "TRANSACTION STATUS": item?.transactionStatus || "-",
                    "DELIVERY STATUS": item?.deliveryStatus || "-",
                    "DATE": item?.salesDate
                        ? moment(item.salesDate).format("DD-MM-YYYY")
                        : item?.paymentDate
                            ? moment(item.paymentDate).format("DD-MM-YYYY")
                            : "-",
                };
                return row;
            });
        };

        const wb = XLSX.utils.book_new();

        if (selectedRows && selectedRows.length > 0) {
            // Download only selected rows
            const selectedData = sourceData.filter((d) =>
                selectedRows.includes(d?.orderId) || selectedRows.includes(d?.id)
            );
            if (selectedData.length === 0) {
                toast.warn("No matching selected orders found");
                return;
            }
            const formatted = formatRows(selectedData);
            console.log("Download Excel - selected formatted rows:", formatted.length, formatted[0]);
            const ws = XLSX.utils.json_to_sheet(formatted, { header: headers });
            XLSX.utils.book_append_sheet(wb, ws, "Selected Orders");
        } else {
            // Sheet 1: All Orders
            const allFormatted = formatRows(sourceData);
            console.log("Download Excel - all formatted rows:", allFormatted.length, allFormatted[0]);
            const wsAll = XLSX.utils.json_to_sheet(allFormatted, { header: headers });
            XLSX.utils.book_append_sheet(wb, wsAll, "All Orders");

            // Sheet 2: Pending
            const safePending = sourceData.filter(
                (item) => String(item?.deliveryStatus || "").toLowerCase() !== "delivered"
            );
            if (safePending.length > 0) {
                const wsPending = XLSX.utils.json_to_sheet(formatRows(safePending), { header: headers });
                XLSX.utils.book_append_sheet(wb, wsPending, "Pending");
            }

            // Sheet 3: Completed
            const safeCompleted = sourceData.filter(
                (item) => String(item?.deliveryStatus || "").toLowerCase() === "delivered"
            );
            if (safeCompleted.length > 0) {
                const wsCompleted = XLSX.utils.json_to_sheet(formatRows(safeCompleted), { header: headers });
                XLSX.utils.book_append_sheet(wb, wsCompleted, "Completed");
            }
        }

        XLSX.writeFile(wb, "View Orders.xlsx");
        toast.success("Excel downloaded successfully!");
    };

    return (
        <>
            <div className="view_form_block">
                <div className="view_form_sub_block">
                    {/* DASHBOARD */}
                    <div className="row my-3 d-flex justify-content-center">
                        <div
                            className="col-12 col-sm-6 col-lg-2 dashborad-card-block --first-block"
                            onClick={() => { setSelectedRows([]); refetch(); }}
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="dashboard-heading" style={{ color: "#4B5563" }}>
                                OverAll
                            </span>
                            <span className="dashboard-value">{overallOrdes || 0}</span>
                        </div>
                        <div
                            className="col-12 col-sm-6  col-lg-2 dashborad-card-block"
                            onClick={() => { setActiveTab('pending'); setSelectedRows([]); refetch(); }}
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="dashboard-heading" style={{ color: "#92400E" }}>
                                Processing
                            </span>
                            <span className="dashboard-value">{processingCount || 0}</span>
                        </div>
                        <div
                            className="col-12 col-sm-6  col-lg-2 dashborad-card-block"
                            onClick={() => { setActiveTab('pending'); setSelectedRows([]); refetch(); }}
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="dashboard-heading" style={{ color: "#7F1D1D" }}>
                                Canceled
                            </span>
                            <span className="dashboard-value">{CanceledCount || 0}</span>
                        </div>
                        <div
                            className="col-12 col-sm-6 col-lg-2 dashborad-card-block"
                            onClick={() => { setActiveTab('pending'); setSelectedRows([]); refetch(); }}
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="dashboard-heading" style={{ color: "#1E40AF" }}>
                                Return
                            </span>
                            <span className="dashboard-value">{returnedCount || 0}</span>
                        </div>

                        <div
                            className="col-12 col-sm-6  col-lg-2 dashborad-card-block --last-block"
                            onClick={() => { setActiveTab('completed'); setSelectedRows([]); refetch(); }}
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="dashboard-heading" style={{ color: "#065F46" }}>
                                Delivered
                            </span>
                            <span className="dashboard-value">{deliveredCount || 0}</span>
                        </div>
                    </div>
                    {/* ====== ROW 1 (Date + Filters Card) ====== */}
                    <div className="card border-0 shadow-sm p-3 mb-3 bg-white">
                        <div className="row g-3 align-items-center">
                            <label className="col-auto mb-0 text-slate-600 fw-bold">Filter by date : </label>
                            {/* From Date */}
                            <div className="col-auto w-100-mobile">
                                <Controller
                                    control={control}
                                    name="fromDate"
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            selected={field.value}
                                            onChange={field.onChange}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="From Date"
                                            maxDate={new Date()}
                                            className="filter_date_picker w-100"
                                        />
                                    )}
                                />
                            </div>

                            {/* To Date */}
                            <div className="col-auto w-100-mobile">
                                <Controller
                                    control={control}
                                    name="toDate"
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            selected={field.value}
                                            onChange={field.onChange}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="To Date"
                                            minDate={fromDate}
                                            maxDate={new Date()}
                                            className="filter_date_picker w-100"
                                        />
                                    )}
                                />
                            </div>

                            {/* Search */}
                            <div className="col-auto flex-grow-1">
                                <input
                                    type="search"
                                    className="form-control view_table_search w-100"
                                    placeholder="Search by customer"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ====== ROW 2 (Tabs + Action Buttons Card) ====== */}
                    <div className="card border-0 shadow-sm p-3 mb-4 bg-white">
                        <div className="row g-3 align-items-center">
                            <div className="col-12 d-flex flex-wrap align-items-center justify-content-between gap-3">
                                {/* ---- Pending / Completed Buttons ---- */}
                                <div className="d-flex gap-3 flex-wrap">
                                    <button
                                        type="button"
                                        className={`btn ${activeTab === "pending"
                                            ? "btn-primary"
                                            : "btn-outline-primary"
                                            }`}
                                        onClick={() => {
                                            setActiveTab("pending");
                                            setSelectedRows([]);
                                        }}
                                    >
                                        Processing ({pendingDetails?.length || 0})
                                    </button>

                                    <button
                                        type="button"
                                        className={`btn ${activeTab === "completed"
                                            ? "btn-primary"
                                            : "btn-outline-primary"
                                            }`}
                                        onClick={() => {
                                            setActiveTab("completed");
                                            setSelectedRows([]);
                                        }}
                                    >
                                        Completed ({completedDetails?.length || 0})
                                    </button>
                                </div>

                                {/* ---- Right Side Action Buttons ---- */}
                                <div className="d-flex gap-2 flex-wrap">
                                    {/* New Order */}
                                    <div
                                        className="download_btn_block_order"
                                        onClick={() => navigate("/newOrder")}
                                    >
                                        <button className="download_btn">NEW ORDER</button>
                                    </div>

                                    {/* Download */}
                                    <div
                                        className="download_btn_block_order"
                                        onClick={downloadExcel}
                                    >
                                        <button className="download_btn">
                                            DOWNLOAD
                                        </button>
                                    </div>

                                    {/* Delete (Shown if rows selected) */}
                                    {selectedRows?.length > 0 && (
                                        <div
                                            className="download_btn_block_purchase"
                                            onClick={() => handleDelete()}
                                        >
                                            <button className="download_btn">
                                                DELETE ({selectedRows?.length})
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row px-3 my-3">
                        <div className="col-lg-12 view_table_section">
                            <div className="table-responsive view_table_block">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="view-table-heading">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        style={{
                                                            accentColor: "blue",
                                                            width: "18px",
                                                            height: "18px",
                                                            cursor: "pointer",
                                                        }}
                                                        checked={isAllSelected}
                                                        onChange={handleSelectAll}
                                                    />
                                                    SELECT
                                                </div>
                                            </th>
                                            <th className="view-table-heading">ID</th>
                                            <th className="view-table-heading">CUSTOMER</th>
                                            <th className="view-table-heading">PRODUCT</th>
                                            <th className="view-table-heading">TOTAL</th>
                                            <th className="view-table-heading">RECEIVED</th>
                                            <th className="view-table-heading">BALANCE</th>
                                            <th className="view-table-heading">TRANSACTION STATUS</th>
                                            <th className="view-table-heading">DELIVERY STATUS</th>
                                            <th className="view-table-heading">PAYMENT DATE</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {isLoading ? (
                                            <tr>
                                                <td colSpan="10" className="text-center py-3">
                                                    <h5>L O A D I N G . . .</h5>
                                                </td>
                                            </tr>
                                        ) : rowsToShow?.length > 0 ? (
                                            rowsToShow?.map((data, i) => (
                                                <tr
                                                    key={i}
                                                    onClick={() => {
                                                        navigate("/invoice", { state: data });
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <td className="view-table-data" onClick={(e) => e.stopPropagation()}>
                                                        <div className="d-flex align-items-center gap-2">
                                                            {/* ✅ Checkbox */}
                                                            <input
                                                                type="checkbox"
                                                                style={{
                                                                    accentColor: "blue",
                                                                    width: "18px",
                                                                    height: "18px",
                                                                    cursor: "pointer",
                                                                }}
                                                                checked={(selectedRows || []).includes(data?.orderId || data?.id)}
                                                                onChange={() => handleCheckboxChange(data?.orderId || data?.id)}
                                                            />

                                                            {/* ✅ Edit Button for all tabs */}
                                                            <button
                                                                type="button"
                                                                className="btn  btn-outline-primary"
                                                                style={{
                                                                    padding: "2px 10px",
                                                                    fontSize: "12px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    navigate("/newOrder", {
                                                                        state: data,
                                                                    });
                                                                }}
                                                            >
                                                                Edit
                                                            </button>
                                                            {/* Print button */}
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-secondary ms-1"
                                                                style={{ padding: "2px 8px", fontSize: "12px" }}
                                                                onClick={(e) => { e.stopPropagation(); handleOpenPrintPopup(data); }}
                                                            >
                                                                🖨️
                                                            </button>
                                                        </div>
                                                    </td>

                                                    <td className="view-table-data">{data?.orderId || '-'}</td>
                                                    <td className="view-table-data">{data?.customerName || '-'}</td>
                                                    <td className="view-table-data">
                                                        {data?.items && data?.items.length > 0
                                                            ? data.items.length > 1
                                                                ? `${data.items[0]?.productName} + ${data.items.length - 1} more`
                                                                : data.items[0]?.productName
                                                            : '-'}
                                                    </td>
                                                    <td className="view-table-data">{data?.totalAmount ?? 0}</td>
                                                    <td className="view-table-data">{data?.receivedAmount ?? 0}</td>
                                                    <td className="view-table-data">{data?.balanceAmount ?? 0}</td>
                                                    <td className="view-table-data">{data?.transactionStatus || '-'}</td>
                                                    <td className="view-table-data">{data?.deliveryStatus || '-'}</td>
                                                    <td className="view-table-data">{data?.paymentDate ? moment(data?.paymentDate).format('DD-MM-YYYY') : data?.salesDate ? moment(data?.salesDate).format('DD-MM-YYYY') : '-'}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" className="text-center py-3">
                                                    <h6>No Records Found</h6>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* POS Print Popup */}
            {isPopupOpen && (
                <div
                    className="modal fade show d-block"
                    style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh', background: 'rgba(0,0,0,0.55)', zIndex: 99999 }}
                    data-bs-backdrop="static"
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content p-4" ref={popupRef}>
                            <div className="text-center mb-3 border-bottom pb-2">
                                <h5 className="fw-bold mb-1">New Vinayaga Snacks & Confectioneries</h5>
                                <p className="small mb-0">No:3/132 Pillaiyar Koil Street, Sathankuppam,</p>
                                <p className="small mb-0">Kelambakkam - 603103, Tamilnadu</p>
                                <p className="small mb-0 fw-bold">Mobile : 9074420538</p>
                            </div>

                            <div className="d-flex justify-content-between mb-3" style={{ fontSize: "12px", gap: "20px" }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                        <span style={{ width: "70px", flexShrink: 0, fontWeight: "bold" }}>Customer</span>
                                        <span style={{ width: "12px", flexShrink: 0 }}>:</span>
                                        <span style={{ fontWeight: "600", wordBreak: "break-all" }}>{orderFormData?.customerName || "-"}</span>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "4px" }}>
                                        <span style={{ width: "70px", flexShrink: 0, fontWeight: "bold" }}>Mobile</span>
                                        <span style={{ width: "12px", flexShrink: 0 }}>:</span>
                                        <span>{orderFormData?.contactNumber || orderFormData?.contact || "-"}</span>
                                    </div>
                                    {orderFormData?.invoiceNo && (
                                        <div style={{ display: "flex", alignItems: "center", marginTop: "4px" }}>
                                            <span style={{ width: "70px", flexShrink: 0, fontWeight: "bold" }}>Invoice</span>
                                            <span style={{ width: "12px", flexShrink: 0 }}>:</span>
                                            <span>#{orderFormData.invoiceNo}</span>
                                        </div>
                                    )}
                                </div>
                                <div style={{ flexShrink: 0 }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span style={{ width: "45px", flexShrink: 0, fontWeight: "bold" }}>Date</span>
                                        <span style={{ width: "12px", flexShrink: 0 }}>:</span>
                                        <span style={{ minWidth: "80px" }}>{moment(orderFormData?.salesDate).format("DD-MM-YYYY")}</span>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "4px" }}>
                                        <span style={{ width: "45px", flexShrink: 0, fontWeight: "bold" }}>Mode</span>
                                        <span style={{ width: "12px", flexShrink: 0 }}>:</span>
                                        <span style={{ fontWeight: "600", minWidth: "80px" }}>{orderFormData?.transactionMode || "-"}</span>
                                    </div>
                                </div>
                            </div>

                            <h6 className="pop-up-order-content mt-2">Order Details</h6>
                            <div className="table-responsive">
                                <table style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th className="popup-table-head">Item Name</th>
                                            <th className="popup-table-head">Quantity</th>
                                            <th className="popup-table-head">Price</th>
                                            <th className="popup-table-head">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(orderFormData?.items || []).map((data, index) => {
                                            const itemTotal = data?.price ? Number(data?.price || 0) : (Number(data?.quantity || 0) * Number(data?.unitPrice || 0));
                                            return (
                                                <tr key={index}>
                                                    <td className="popup-table-data">{data?.productName || "-"}</td>
                                                    <td className="popup-table-data">{data?.quantity || 0}</td>
                                                    <td className="popup-table-data">{data?.unitPrice || 0}</td>
                                                    <td className="popup-table-data">{itemTotal || 0}</td>
                                                </tr>
                                            );
                                        })}
                                        <tr>
                                            <td className="popup-table-data" style={{ borderBottom: "2px dashed black", borderTop: "2px dashed black" }}>Total Items</td>
                                            <td className="popup-table-data" style={{ borderBottom: "2px dashed black", borderTop: "2px dashed black" }}>{(orderFormData?.items || []).reduce((s, i) => s + Number(i?.quantity || 0), 0)}</td>
                                            <td className="popup-table-data" style={{ borderBottom: "2px dashed black", borderTop: "2px dashed black" }}></td>
                                            <td className="popup-table-data" style={{ borderBottom: "2px dashed black", borderTop: "2px dashed black" }}></td>
                                        </tr>
                                        {Number(orderFormData?.discount || 0) > 0 && (
                                            <tr>
                                                <td colSpan="3" className="popup-table-data" style={{ textAlign: "right", borderBottom: "2px dashed black", padding: "4px" }}>Discount</td>
                                                <td className="popup-table-data text-danger" style={{ borderBottom: "2px dashed black", padding: "4px" }}>- {Number(orderFormData.discount).toFixed(2)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <p className="invoice-total">
                                <span>Total</span>
                                <span>{orderFormData?.totalAmount || 0}</span>
                            </p>
                            <div style={{ marginTop: "20px", textAlign: "center", fontSize: "12px", fontWeight: "600" }}>
                                Goods Once Sold cannot be taken back<br />
                                Thank You !!! Visit Again !!!
                            </div>
                            <div className="d-flex justify-content-center mt-5 gap-2 align-items-center">
                                <button
                                    type="button"
                                    className="invoice-print-button"
                                    onClick={handleSelfTest}
                                >
                                    SELF TEST
                                </button>

                                <button
                                    type="button"
                                    className="invoice-print-button"
                                    onClick={handlePrint}
                                >
                                    PRINT
                                </button>

                                <button
                                    type="button"
                                    className="invoice-print-button"
                                    onClick={handlePopupCancel}
                                >
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ViewSales;
